import services from '@/services/admin';
import { setBuilderLocales } from '@/router/Admin/builderManuals';
import { i18n } from '@/i18n';
import { currencyMap } from '@/constants/default';

export const Locales = {
  namespaced: true,
  state() {
    return {
      supportedLocales: [],
      requiredLocales: [],
      locales: [],
      currentSupportedLang: process.env.VUE_APP_I18N_LOCALE || 'ru',
      currency: '',
    };
  },
  getters: {
    supportedLocales: (state) => state.supportedLocales.map((x) => x.locale),
    requiredLocales: (state) => state.requiredLocales.map((x) => x.locale),
    locales: (state) => state.supportedLocales.map((lang) => {
      const isRequired = Boolean(state.requiredLocales
        .find((loc) => loc.locale === lang.locale));

      return {
        value: lang.locale,
        isRequired,
      };
    }),
    currentLocaleIndex: (state, rootState, rootGetters) => {
      const userLocale = rootGetters?.UserData?.user?.locale || i18n.global.locale.value;
      const index = state.supportedLocales.findIndex((lang) => lang.locale === userLocale);
      return index > -1 ? index : 0;
    },
    currentSupportedLang: (state) => {
      const lastUsedLang = i18n.global.locale.value;
      const isSupported = state.supportedLocales
        .find((lang) => [lang, lang?.locale].includes(lastUsedLang));
      return isSupported ? lastUsedLang : process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en';
    },
    currency: (state) => state.currency || 'RUB',
    currencySign: (state) => currencyMap[state.currency],
  },
  actions: {
    async getSupportedLocales({ commit }) {
      const data = await services.getSupportedLocales();
      // const data = [{ locale: 'en' }]; // for local tests
      commit('SET_SUPPORTED_LOCALES', data);
    },
    async getRequiredLocales({ commit }) {
      const data = await services.getRequiredLocales();
      commit('SET_REQUIRED_LOCALES', data);
    },
  },
  mutations: {
    SET_SUPPORTED_LOCALES: (state, data) => {
      state.supportedLocales = data;
      setBuilderLocales(state.supportedLocales.map((x) => x.locale));
    },
    SET_REQUIRED_LOCALES: (state, data) => {
      state.requiredLocales = data;
    },
    SET_CURRENCY: (state, data) => {
      state.currency = data;
    },
  },
};

export default {
  Locales,
};
